import {AppSettingsRepo, SettingsKeys} from "../../domain/settings/IAppSettingsRepo";

const persistJWT = async (token: string) => {
    await AppSettingsRepo.set(SettingsKeys.authToken, token);
}

export default persistJWT;